import React, { useState, useEffect } from 'react';

export default function ConfirmAlert(props) {
  // props.onConfirm
  // props.onClose
  // props.text
  return (
    <div className="flex flex-col bg-cust-gray items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none pb-4">
      <ul className="py-24">
        <li>
          <span className="font-bold">{props.text}</span>
        </li>
      </ul>
      <div className="flex flex-row justify-start items-end">
        <button
          className="justify-center items-center w-40 h-12 font-bold text-black bg-cust-medium-gray mx-2"
          onClick={props.onClose}>
          취소
        </button>
        <button
          className="justify-center items-center w-40 h-12 font-bold text-white bg-primary mx-2"
          onClick={() => {
            props.onConfirm(props.item);
            props.onClose();
          }}>
          확인
        </button>
      </div>
    </div>
  );
}
